import $ from 'domtastic'
import EventBus from '../../EventBus.vue'



/* RADIO TOGGLE
----------------------------------------------------------------------------------------------------*/

export default class CheckoutDeliveryRadioRefresh {

    constructor($el) {
        this.$els = {
            price    : $el.find('.js-sendblock-title'),
            radios : $el.find('.formRadio'),
        }
        this.parser = new DOMParser()

        this.bindEvents()
    }


    bindEvents() {
        this.$els.radios.on('change', (e) => {
            const val = e.target.value
            this.loadHtml(`${window.location.href}?delivery_method=${val}`)
        })
    }




    /* Handlers
    --------------------------------------------------------- */




    /* Actions
    --------------------------------------------------------- */




    /* Methods
    --------------------------------------------------------- */
    loadHtml(url) {
        const h = new Headers()
        h.append('X-Requested-With', 'XMLHttpRequest')
        h.append('Cache-Control', 'no-store')
        h.append('Pragma', 'no-cache')
        h.append('Expires', '0')

        const fetchOptions = {
            headers     : h,
            credentials : 'same-origin',
        }

        this.loading = true

        fetch(url, fetchOptions)
            .then(r => r.text())
            .then((html) => {
                const dom = this.parser.parseFromString(html, 'text/html')
                const price = dom.querySelector('.js-sendblock-title')
                this.$els.price.html(price.innerHTML)
            })
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



